"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboDefaultSubsidyForAttempt = exports.getComboDefaultSubsidy = exports.PERSONAL_COMBO_SAVINGS_PREMIUM_COEFFICIENT = void 0;
const LOW_SAVINGS_PERCENTAGE = 15;
const HIGH_SAVINGS_PERCENTAGE = 40;
const SAVINGS_RANGE_SIZE = HIGH_SAVINGS_PERCENTAGE - LOW_SAVINGS_PERCENTAGE;
const MAX_SUBSIDY_ADJUSTMENT = 20;
exports.PERSONAL_COMBO_SAVINGS_PREMIUM_COEFFICIENT = 0.2;
const PERSONAL_COMBO_SAVINGS_PREMIUM_PERCENTAGE = exports.PERSONAL_COMBO_SAVINGS_PREMIUM_COEFFICIENT * 100;
const getComboDefaultSubsidy = ({ isPersonal, savingsPercentage, savings, }) => {
    // Limit the range of the savings percentage between 15 and 40%
    const cappedSavingsPercentage = Math.min(savingsPercentage, HIGH_SAVINGS_PERCENTAGE);
    const adjustedSavingsPercentage = Math.max(cappedSavingsPercentage, LOW_SAVINGS_PERCENTAGE);
    const savingsRangePlacement = (adjustedSavingsPercentage - LOW_SAVINGS_PERCENTAGE) / SAVINGS_RANGE_SIZE;
    // Set the savings split between 80% and 50% decreasing the Daytrip fee for best combos
    let daytripFeeInPercent = 80 - savingsRangePlacement * MAX_SUBSIDY_ADJUSTMENT;
    // For personal combos profitability for drivers is increased by percentage of combo savings
    if (isPersonal) {
        daytripFeeInPercent = daytripFeeInPercent - PERSONAL_COMBO_SAVINGS_PREMIUM_PERCENTAGE;
    }
    const negativeSubsidy = Math.floor(savings * (daytripFeeInPercent / 100)) * -1;
    return negativeSubsidy;
};
exports.getComboDefaultSubsidy = getComboDefaultSubsidy;
const getComboDefaultSubsidyForAttempt = (recommendedSubsidy, failedAttempts) => {
    if (failedAttempts === 1) {
        return Math.round(recommendedSubsidy * 0.667);
    }
    if (failedAttempts > 1) {
        return Math.round(recommendedSubsidy * 0.333);
    }
    return recommendedSubsidy;
};
exports.getComboDefaultSubsidyForAttempt = getComboDefaultSubsidyForAttempt;
//# sourceMappingURL=getComboDefaultSubsidy.js.map